import { render } from "./CorePromiseSection.vue?vue&type=template&id=18b243fa&scoped=true"
import script from "./CorePromiseSection.vue?vue&type=script&lang=js"
export * from "./CorePromiseSection.vue?vue&type=script&lang=js"

import "./CorePromiseSection.vue?vue&type=style&index=0&id=18b243fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b243fa"]])

export default __exports__